import {Component, OnDestroy, OnInit} from '@angular/core';

import {BaseComponent} from "@shared/components/base-component";

import {HandoverNotificationsService} from "@handover/routes/main-route/services/handover-notifications.service";
import {HandoverHttpService} from "@handover/http-services/handover-http.service";
import {VehicleListItem} from "@handover/view-models/vehicle-list-item";
import {HandoverListItem} from "@handover/view-models/handover-list-item";

@Component({
  selector: 'handovermod-right-panel',
  templateUrl: './right-panel.component.html',
})
export class RightPanelComponent extends BaseComponent implements OnInit, OnDestroy {

  isVehicleSelected = false;
  selectedVehicle?: VehicleListItem;
  handovers?: HandoverListItem[];
  hasAnyHandovers = false;
  isLoading = false;
  isHandoverVisible = false;

  get isSelectProtocolInfoVisible(): boolean {
    return this.hasAnyHandovers && !this.isLoading && !this.isHandoverVisible;
  }

  constructor(
    private handoverNotificationsService: HandoverNotificationsService,
    private handoverHttpService: HandoverHttpService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subToSelectedVehicleChanged();

    this.addToUnsubscribe(
      this.handoverNotificationsService.selectedHandoverChanged$.subscribe(handoverId => {
        this.isHandoverVisible = handoverId != null;
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  private subToSelectedVehicleChanged() {
    this.addToUnsubscribe(
      this.handoverNotificationsService.selectedVehicleChanged$.subscribe(vehicle => {
        this.isLoading = true;
        this.hasAnyHandovers = false;
        this.isVehicleSelected = vehicle != null;
        this.selectedVehicle = vehicle;
        if (this.selectedVehicle) {
          this.loadHandoversForVehicle(this.selectedVehicle.vehicleId);
        } else {
          this.handovers = [];
          this.isLoading = false;
        }
      })
    );
  }

  private loadHandoversForVehicle(vehicleId: number) {
    this.handoverHttpService.getVehicleHandovers(vehicleId).subscribe(handovers => {
      this.handovers = handovers.sort((a, b) => b.date.getTime() - a.date.getTime());
      this.hasAnyHandovers = this.handovers.length > 0;
      this.isLoading = false;
    });
  }
}
